var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradientMedical = function SvgGradientMedical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-medical_svg__a)",
    d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-medical_svg__a",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#F37971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#E1E986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7BD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#9AE1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D294D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522755"
  })))));
};
export default SvgGradientMedical;